import { addClass, removeClass, toggleClass } from "./functions";

class accordeon {
    _el                 : HTMLUListElement;
    _mediaQuery         : any;
    _accordeonInit      : boolean;
    _contentClassName   : string;
    _itemClassName      : string;
    _activeItemClassName: string;
    _elChildArray       : Array<Element>;
    _elChildHeightArray : Array<Number>;
    _resizeTimeOut      : number;

    constructor(el: HTMLUListElement, mediaQuery?: any) {
        this._el                  = el;
        this._mediaQuery          = mediaQuery;
        this._contentClassName    = 'accordeon-list';
        this._itemClassName       = 'accordeon-list-item';
        this._activeItemClassName = 'active';
        this._elChildArray        = [];
        this._accordeonInit       = false;
        this._resizeTimeOut       = 350;
    }
    // Init accordeon component
    init = () => {
        if(this._mediaQuery){
            if(this._mediaQuery.matches){
                this.run();
            }
        }else {
            this.run();
        }
        // Add window event listener for the resize
        this.windowEvent();
    }
    run = () => {
        if ( !this._accordeonInit ) {            
            this.getChildren();
            this.setStyle();
            this.addEvent();
            this._accordeonInit = true;
        }
    }
    // Get number of child
    numberChild = () => {
        return this._elChildArray.length;
    }
    // Get children
    getChildren = () => {
        this._elChildArray  = Array.from(<HTMLCollection>this._el.children);
    }
    // Add classes to define style
    setStyle = (set: Boolean = true) =>  {
        // Add class to parent and children to apply style
        set ? addClass( {domElement: this._el, classList: this._contentClassName} ) : removeClass( {domElement: this._el, classList: this._contentClassName} );

        for (let i = 0; i < this.numberChild(); i++) {
            const element = <HTMLLIElement>this._elChildArray[i];

            set ? addClass( {domElement: element, classList: this._itemClassName} ) : removeClass( {domElement: element, classList: this._itemClassName} );
        }
    }
    // Open / close panel 
    updatePanel = (event) => {
        const activeClass = <string>this._activeItemClassName;
        const target = event.target;
        const panel = <HTMLUListElement>target.nextElementSibling;
        toggleClass( {domElement: target.parentElement, classList: activeClass} );

        if (panel.style.maxHeight) {
            panel.style.maxHeight = null;
        } else {
            panel.style.maxHeight = panel.scrollHeight + "px";
        }
    }
    // Window event listener
    windowEvent = () => {
        let timeoutId;
        // Avoid function being called twice on window resize
        window.addEventListener('resize', (e: Event) => {
            window.clearTimeout(timeoutId);
            timeoutId = window.setTimeout(() => {
                (this._mediaQuery) ? (this._mediaQuery.matches ? this.run() : this.destroy()) : this.run();
            }, this._resizeTimeOut);
        });        
    }

    // Add event listener
    addEvent = () => {
        for (let i = 0; i < this.numberChild(); i++) {
            this._elChildArray[i].firstElementChild.addEventListener("click", this.updatePanel, true);
        }

        let timeoutId;
        // Avoid function being called twice on window resize
        window.addEventListener('resize', (e: Event) => {
            window.clearTimeout(timeoutId);
            timeoutId = window.setTimeout(() => {
            (typeof this._mediaQuery != "undefined") ? (this._mediaQuery.matches ? this.init() : this.destroy()) : this.init();
            }, 400);
        });
    }    
    // Remove event listener
    removeEvent = () => {
        for (let i = 0; i < this.numberChild(); i++) {
            this._elChildArray[i].firstElementChild.removeEventListener("click", this.updatePanel, true);
        }
    }
    // Destroy accordeon component
    destroy = () => {
        if( this._accordeonInit ){
            this.setStyle(false);
            this.removeEvent();
            this._accordeonInit = false;
        }
    }
}

export default accordeon;
